
// => Styling
import styles from './DebugMonitor.module.css';

// => Icons
import { 
    IoBugOutline,
    IoChevronDown,
    IoChevronUp,
} from "react-icons/io5";

// => React hooks
import { useState } from 'react';



// ============
// Component
// ============
const DebugMonitor = ({
    enabled = true,
    onToggle,

    overlayFx = true,
    onOverlayFx,
    gamestate = null,
    sendGamestate = () => {},

    forceLoopOverride = false,
    onForceLoopOverride,
    activeClip = null,
    prevClip = null,
    clipTimeCurrent = null,
    clipTimeMax = null,
    clipPlaybackRate = null,
    onPlaybackRate,

    clipTriggerChecked = false,
    clipTriggerTime = null,
    cockDuration = null,
    cockTimer = null,
    cockTriggerChance = null,
    babeSafeTimer = null,
    onCockTriggerChance,
    clips = [],
    onClipSelected,
    
    onDecreaseMasc = null,
    onIncreaseMasc = null,

    onAddCurrency = (v) => {},
    onRemoveCurrency = (v) => {},
}) => {

    const timeFormat = {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        minimumIntegerDigits: 2
    }

    const rateFormat = {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    }

    const recordedTimeFormat = {
        maximumFractionDigits: 3,
        minimumFractionDigits: 3
    }


    const [recordedTimes, setRecordedTimes] = useState([])

    
    function addCurrentTime() {
        let result = recordedTimes
        if (result.length > 2) {
            result = result.slice(-2)
        }
        result.push(clipTimeCurrent)
        setRecordedTimes(result)
    }


    // RENDER
    // ---------
    return(
        <div className={styles.container}>
            
            {/* Header */}
            <div className={styles.header}
                onClick={onToggle}>
                    <span className={styles.title}><IoBugOutline size='1.2em' /> Debug Monitor</span>
                    {enabled ? (
                        <IoChevronDown size='0.85em' />
                    ) : (
                        <IoChevronUp size='0.85em' />
                    )}
            </div>

            {/* Content */}
            <div className={[styles.content, enabled?null:styles.contentHidden].join(" ")}>

                {/* General */}
                <div className={styles.section}>

                    <span className={styles.sectionTitle}>General:</span>

                    <div className={styles.sectionContent}>
                        
                        {/* Buttons */}
                        <div className={styles.sectionItem}>
                            <button onClick={onOverlayFx}>{overlayFx ? "Disable":"Enable"} Overlay FX</button>
                        </div>
                        { gamestate.value === 'startidle' &&
                            <div className={styles.sectionItem}>
                                <button onClick={()=>sendGamestate('START')}>Skip Start</button>
                            </div>
                        }
                        { (gamestate.value === 'babe' || gamestate.value === 'cock') &&
                            <div className={styles.sectionItem}>
                                <div style={{display: 'flex', flexDirection: 'row', gap: '0.5em', justifyContent: 'space-evenly'}}>
                                    <button style={{flex: 1}} onClick={()=>sendGamestate('BABE')}>Babe</button>
                                    <button style={{flex: 1}} onClick={()=>sendGamestate('COCK')}>Cock</button>
                                </div>
                            </div>
                        }

                        {/* Data */}
                        <div className={styles.sectionItem}>overlayFx= {overlayFx.toString() || 'undefined'}</div>
                        <div className={styles.sectionItem}>gamestate= {gamestate?.value || 'undefined'}</div>

                    </div>

                </div>

                {/* Video */}
                <div className={styles.section}>

                    <span className={styles.sectionTitle}>Video:</span>

                    <div className={styles.sectionContent}>

                        {/* Selection */}
                        <div className={styles.sectionItem}>
                            <div style={{display: 'flex', flexDirection: 'row', gap: '0.5em', justifyContent: 'space-evenly'}}>
                                <input type='checkbox' id='forceLoopOverride' checked={forceLoopOverride} onChange={onForceLoopOverride} />
                                <label htmlFor='forceLoopOverride' style={{flex: 1}}>forceLoopOverride</label>
                            </div>
                        </div>
                        <div className={styles.sectionItem}>
                            <select value={activeClip.id}
                                    onChange={onClipSelected}>
                                {clips.map(c =>
                                    <option key={c.id}
                                            value={c.id || ""}
                                            style={{direction: 'rtl'}}>
                                                {c.path + c.file}
                                    </option>
                                )}
                            </select>
                        </div>

                        {/* Data */}
                        <div className={styles.sectionItem}>activeClip= {activeClip?.id}</div>
                        <div className={[styles.sectionItem, styles.sectionItemDeep].join(" ")}>{activeClip?.filePath}</div>
                        <div className={styles.sectionItem}>prevClip= {prevClip?.id || 'undefined'}</div>
                        <div className={[styles.sectionItem, styles.sectionItemDeep].join(" ")}>{prevClip?.filePath || ''}</div>
                        <div className={styles.sectionItem}>clipTime= {
                            clipTimeMax?.toLocaleString("en-US", timeFormat) || 'undefined'} /
                            {" "}{clipTimeCurrent?.toLocaleString("en-US", timeFormat) ||'undefined'}
                        </div>
                        <div className={styles.sectionItem}>clipTriggerTime= {activeClip.triggerTime || 'undefined'}</div>
                        <div className={styles.sectionItem}>clipPlaybackRate= {clipPlaybackRate?.toLocaleString("en-US", rateFormat) || 'undefined'}</div>

                        {/* Buttons */}
                        <div className={styles.sectionItem}>
                            <input type='range' min={10} max={400} value={clipPlaybackRate * 100} onChange={(e)=>onPlaybackRate(e.target.value)} />
                            <div style={{display: 'flex', flexDirection: 'row', gap: '0.5em', justifyContent: 'space-evenly'}}>
                                    <button style={{flex: 1}} onClick={()=>onPlaybackRate(50)}>0.5x</button>
                                    <button style={{flex: 1}} onClick={()=>onPlaybackRate(100)}>1x</button>
                                    <button style={{flex: 1}} onClick={()=>onPlaybackRate(200)}>2x</button>
                                    <button style={{flex: 1}} onClick={()=>onPlaybackRate(400)}>4x</button>
                                    <button style={{flex: 1}} onClick={()=>onPlaybackRate(800)}>8x</button>
                            </div>
                        </div>

                        {/* Time recording */}
                        <button onClick={()=>addCurrentTime()}>Record current clip time</button>
                        <div className={styles.sectionItem}>
                            <div style={{display: 'flex', flexDirection: 'column', gap: '0.1em', justifyContent: 'flex-end'}}>
                            Recorded times:
                            {(recordedTimes.length === 0) && <span>none</span>}
                            {recordedTimes.map((e, index) =>
                                <span key={"recTime" + index}>[{e?.toLocaleString("en-US", recordedTimeFormat)}]</span>
                            )}
                            </div>
                        </div>

                    </div>

                </div>

                {/* Clip trigger */}
                <div className={styles.section}>

                    <span className={styles.sectionTitle}>Clip trigger:</span>

                    <div className={styles.sectionContent}>

                        <div className={styles.sectionItem}>clipTriggerChecked= {clipTriggerChecked.toString()}</div>
                        <div className={styles.sectionItem}>clipTriggerTime= {clipTriggerTime || 'undefined'}</div>
                        <div className={styles.sectionItem}>cockDuration= {cockDuration?.toLocaleString("en-US", rateFormat) || 'null'} / {cockTimer?.toLocaleString("en-US", rateFormat) || 'null'} </div>
                        <div className={styles.sectionItem}>babeSafeTimer= {babeSafeTimer?.toLocaleString("en-US", timeFormat) || 'undefined'}</div>
                        
                        <div className={styles.sectionItem}>cockTriggerChance= {cockTriggerChance}%</div>
                        <input className={styles.sectionItem} type='range' min={0} max={100} value={cockTriggerChance} onChange={(e)=>onCockTriggerChance(e.target.value)} />
                        
                        <div className={styles.sectionItem}>
                            <div style={{display: 'flex', flexDirection: 'row', gap: '0.5em', justifyContent: 'space-evenly'}}>
                                <button style={{flex: 1}} onClick={()=>onDecreaseMasc(10)}>-10Msc</button>
                                <button style={{flex: 1}} onClick={()=>onDecreaseMasc(1)}>-1Msc</button>
                                <button style={{flex: 1}} onClick={()=>onIncreaseMasc(1)}>+1Msc</button>
                                <button style={{flex: 1}} onClick={()=>onIncreaseMasc(10)}>+10Msc</button>
                            </div>
                        </div>

                    </div>
                </div>

                {/* Currency */}
                <div className={styles.section}>

                    <span className={styles.sectionTitle}>Currency</span>

                    <div className={styles.sectionContent}>
                        
                        <div className={styles.sectionItem}>
                            <div style={{display: 'flex', flexDirection: 'row', gap: '0.5em', justifyContent: 'space-evenly'}}>
                                <button style={{flex: 1}} onClick={()=>onRemoveCurrency(5)}>-5 Currency</button>
                                <button style={{flex: 1}} onClick={()=>onAddCurrency(10)}>+10 Currency</button>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

        </div>
    )
}


export default DebugMonitor